import { CircularProgress } from '@mui/material';
import PlayCircleOutline from '@mui/icons-material/PlayCircleOutline';
import StopCircleOutlined from '@mui/icons-material/StopCircleOutlined';

const playActionIconSx = { fontSize: '1.5rem', width: '1.5rem', height: '1.5rem' } as const;

type FlowControlPlayActionIconProps = {
  showSpinner: boolean;
  showStop: boolean;
};

/** Play / stop / pending spinner for flow-control playlist rows. */
export function FlowControlPlayActionIcon({ showSpinner, showStop }: FlowControlPlayActionIconProps) {
  if (showSpinner) {
    return <CircularProgress color="info" size={24} sx={playActionIconSx} />;
  }
  if (showStop) {
    return <StopCircleOutlined sx={playActionIconSx} />;
  }
  return <PlayCircleOutline sx={playActionIconSx} />;
}
